import { render, staticRenderFns } from "./btn-icon-tertiary.vue?vue&type=template&id=78b6be8d&scoped=true"
import script from "./btn-icon-tertiary.vue?vue&type=script&lang=js"
export * from "./btn-icon-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6be8d",
  null
  
)

export default component.exports